import { render, staticRenderFns } from "./mdc-headline1.vue?vue&type=template&id=6e66f554&"
import script from "./mdc-headline1.vue?vue&type=script&lang=ts&"
export * from "./mdc-headline1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports